import React, { useState, useEffect } from 'react'
import { useStore, useDispatch } from 'react-redux'
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import CardAcceptance from './master-card-acceptance'
import CheckAcceptance from './master-check-acceptance'
import AchAcceptance from './master-ach-acceptance'
import { Panel } from 'rsuite';

const MasterInformation = ({ masterDetails, isMergeMaster = true }) => {
    const store = useStore().getState()
    const dispatch = useDispatch()
    const {
        app: { relatedSupplierColumns },
    } = store
    const [phoneNumber, setPhoneNumber] = useState('')

    useEffect(() => {
        // set basic info phone number
        var phoneNumber = masterDetails?.phone
        const usArray = ['united states', 'usa', 'us']
        phoneNumber = !phoneNumber ? '' : masterDetails?.['country'] && usArray.includes(masterDetails?.['country'].toLowerCase()) && phoneNumber.startsWith('1') ? phoneNumber : ((masterDetails?.['country'] && !usArray.includes(masterDetails?.['country'].toLowerCase()))) ? phoneNumber : phoneNumber.startsWith('1') ? phoneNumber : '1 ' + phoneNumber
        setPhoneNumber(phoneNumber)
    }, [masterDetails])

    const headerColumns = [
        {
            name: 'suppliername',
            label: 'Supplier Name'
        },
        {
            name: 'address1',
            label: 'Address 1'
        },
        {
            name: 'address2',
            label: 'Address 2'
        },
        {
            name: 'phone',
            label: 'Phone No'
        },
        {
            name: 'city',
            label: 'City'
        },
        {
            name: 'email',
            label: 'Email'
        },
        {
            name: 'state',
            label: 'State'
        },
        {
            name: 'sic',
            label: 'SIC Code'
        },
        {
            name: 'zip',
            label: 'Zip'
        },
        {
            name: 'naics',
            label: 'NAICS Code'
        },
        {
            name: 'country',
            label: 'Country'
        },
        {
            name: 'url',
            label: 'URL'
        },
        {
            name: 'employerIdNumber',
            label: 'Employer Id Number'
        }
    ]
    const getSupplierBasicInfo = () => {
        let infoColumns = isMergeMaster ? relatedSupplierColumns : headerColumns
        return (
            <div className={`${isMergeMaster ? '' : 'row'}`}>
                {infoColumns.map((col, index) => (
                    <React.Fragment key={col.name}>
                        {
                            isMergeMaster ? (index === 1) : (index === 2) && (
                                <div className={`${isMergeMaster ? 'row g-0' : 'col-6'} align-items-center pb-3" key="masterid`}>
                                    {!isMergeMaster ?
                                        <div className='d-flex align-items-center'>
                                            <h4 className="label mb-0 col-5 text-black">Supplier Id:</h4>
                                            <div className='col-7'>
                                                <input
                                                    className='master-supplier-id w-100 search-input'
                                                    type="text"
                                                    value={masterDetails['id'] || ''}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                        :
                                        <>
                                            <h4 className="label mb-0 col-5 text-black">Supplier Id:</h4>
                                            <div className='col-7'>
                                                <input
                                                    className='master-supplier-id w-100 search-input'
                                                    type="text"
                                                    value={masterDetails['id'] || ''}
                                                    disabled={true}
                                                />
                                            </div>
                                        </>
                                    }

                                </div>
                            )
                        }
                        <div className={`${isMergeMaster ? 'row g-0' : 'col-6'} align-items-center pb-3`} key={col.name}>
                            {!isMergeMaster ? <div className='d-flex align-items-center'>
                                <h4 className="label mb-0 col-5 text-black">{col.label}:</h4>
                                <div className={`col-7`}>
                                    {col.name === 'phone' ?
                                        <div className="phone-input-parent flex align-center">
                                            <div className='d-flex border rounded border-dark phone-input-ext-container w-100 flex-column flex-lg-row'>
                                                <ReactPhoneInput
                                                    className='phone-input-parent w-100 search-input'
                                                    country={'us'}
                                                    value={phoneNumber}
                                                    countryCodeEditable={false}
                                                    preferredCountries={['us']}
                                                    buttonClass='border-0 border-end border-dark'
                                                    inputProps={{
                                                        className: 'form-control border-0'
                                                    }}
                                                    disabled={true}
                                                />
                                                <div className="input-group phone-extension-container mb-0 flex-nowrap">
                                                    <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                                                    <input
                                                        type="text"
                                                        className="shadow-none form-control w-auto border-0 ps-3 pe-3"
                                                        placeholder="phone extension"
                                                        value={masterDetails['phoneExtension'] || ''}
                                                        disabled={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        col.name === 'email' ?
                                            <div className="phone-input-parent flex align-center">
                                                <input
                                                    className={`basicvalue w-100 search-input`}
                                                    type="text"
                                                    value={masterDetails[col.name] || ''}
                                                    disabled={true}
                                                />
                                            </div>
                                            :
                                            <input
                                                className={`basicvalue  w-100 search-input`}
                                                type="text"
                                                value={masterDetails[col.name] || ''}
                                                disabled={true}
                                            />
                                    }
                                </div>
                            </div>
                                :
                                <>
                                    <h4 className="label mb-0 col-5 text-black">{col.label}:</h4>
                                    <div className='col-7'>
                                        {col.name === 'phone' ?
                                            <div className="phone-input-parent flex align-center">
                                                <div className='d-flex border rounded border-dark phone-input-ext-container w-100 flex-column flex-lg-row'>
                                                    <ReactPhoneInput
                                                        className='phone-input-parent w-100 search-input'
                                                        country={'us'}
                                                        value={phoneNumber}
                                                        countryCodeEditable={false}
                                                        preferredCountries={['us']}
                                                        buttonClass='border-0 border-end border-dark'
                                                        inputProps={{
                                                            className: 'form-control border-0'
                                                        }}
                                                        disabled={true}
                                                    />
                                                    <div className="input-group phone-extension-container mb-0 flex-nowrap">
                                                        <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                                                        <input
                                                            type="text"
                                                            className="shadow-none form-control w-auto border-0 ps-3 pe-3"
                                                            placeholder="phone extension"
                                                            value={masterDetails['phoneExtension'] || ''}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            col.name === 'email' ?
                                                <div className="phone-input-parent flex align-center">
                                                    <input
                                                        className={`basicvalue w-100 search-input`}
                                                        type="text"
                                                        value={masterDetails[col.name] || ''}
                                                        disabled={true}
                                                    />
                                                </div>
                                                :
                                                <input
                                                    className={`basicvalue  w-100 search-input`}
                                                    type="text"
                                                    value={masterDetails[col.name] || ''}
                                                    disabled={true}
                                                />
                                        }
                                    </div>
                                </>
                            }
                        </div>
                    </React.Fragment>
                ))}
            </div>
        )
    }

    return (
        <div>
            {isMergeMaster ?
                getSupplierBasicInfo()
                :
                <Panel header={"Supplier Information"} className="supply-card-acceptance" collapsible bordered defaultExpanded={true}>
                    {getSupplierBasicInfo()
                    }
                </Panel>
            }
            <div className='row g-0 mt-5 align-items-center supply-acceptance gap-0'>
                {isMergeMaster && <h4 className='col-5 fw-bold text-blue mb-0'>Acceptance Information</h4>}
                <div className={`${isMergeMaster ? 'col-7' : 'col-12'}`}>
                    <CardAcceptance masterSupplierDetails={masterDetails} isMergeMaster={isMergeMaster} />
                </div>
            </div>
            <div className='row g-0 mt-5 align-items-center supply-acceptance gap-0'>
                {isMergeMaster && <h4 className='col-5 fw-bold text-blue mb-0'>Check Acceptance Information</h4>}
                <div className={`${isMergeMaster ? 'col-7' : 'col-12'}`}>
                    <CheckAcceptance masterDetails={masterDetails} isMergeMaster={isMergeMaster} />
                </div>
            </div>
            <div className='row g-0 mt-5 align-items-center supply-acceptance gap-0'>
                {isMergeMaster && <h4 className='col-5 fw-bold text-blue mb-0'>ACH Acceptance Information</h4>}
                <div className={`${isMergeMaster ? 'col-7' : 'col-12'}`}>
                    <AchAcceptance masterDetails={masterDetails} isMergeMaster={isMergeMaster} />
                </div>
            </div>
        </div>
    )
}

export default MasterInformation